import { z } from 'zod';
import { companyUidValueSchema } from '../../partner-cockpit/onboarding/validationStep.js';
import { partnerCompanyTypeSchema } from '../partnerCompanyType.js';
import { consolidationMergeResolutionSchema } from './consolidationMerge.js';
// Complete or absent: a half-filled address is no use to the debt collection it is recorded for.
export const validationResidentialAddressSchema = z.object({
    street: z.string().min(1),
    nr: z.string().nullish(),
    zip: z.string().min(1),
    city: z.string().min(1),
});
export const validationWorkCategoriesSelectionSchema = z.object({
    keys: z.array(z.string()),
    answers: z.record(z.string(), z.record(z.string(), z.unknown())),
});
// A draft save: every field is optional and none of them moves the ticket's status.
export const updateValidationTicketSchema = z.object({
    companyUid: companyUidValueSchema.nullish(),
    companyType: partnerCompanyTypeSchema.nullish(),
    dateOfBirth: z.coerce.date().min(new Date('1901-01-01')).nullish(),
    residentialAddress: validationResidentialAddressSchema.nullish(),
    insuranceExpirationDate: z.coerce.date().nullish(),
    districtIds: z.array(z.number().int().positive()).nullish(),
    workCategories: validationWorkCategoriesSelectionSchema.nullish(),
    mergeResolution: consolidationMergeResolutionSchema.nullish(),
});
